/**
 * @generated SignedSource<<7602f60c24ff12042924a53a517aeba1>>
 * @relayHash 79ac3e4d2e67a0de50fea8a53e0f9fae
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-15T19:15:12.814Z/AddressFormWrapperQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddressFormWrapperQuery$variables = {
  canCheckZipCode: boolean;
  country?: string | null;
  zipCode?: string | null;
};
export type AddressFormWrapperQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AddressForm_viewer">;
  };
};
export type AddressFormWrapperQuery = {
  response: AddressFormWrapperQuery$data;
  variables: AddressFormWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "canCheckZipCode"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "country"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "zipCode"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "abbreviation",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddressFormWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AddressForm_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddressFormWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Geography",
            "kind": "LinkedField",
            "name": "geography",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "countries",
                "plural": true,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "usStates",
                "plural": true,
                "selections": (v1/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "canCheckZipCode",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "zipCodeLookUp",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "country"
                  },
                  {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "zipCode"
                  }
                ],
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "zipCode",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-15T19:15:12.814Z/AddressFormWrapperQuery",
    "metadata": {},
    "name": "AddressFormWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8bb5ea6d4c9e8f2e354fd20b3fd090cc";

export default node;
